import {usePage} from "@inertiajs/vue3";

export function useLanguageSelectList() {
    const availableLocales = usePage().props.localizationState.availableLocales;
    if (availableLocales.length === 0)
        return [
            {
                'value': 'en',
                'label': 'English',
            }
        ];
    else {
        let locales = [];
        Object.keys(availableLocales).forEach((locale) => {
            let entry = availableLocales[locale];
            locales.push({
                'value': locale,
                'label': entry.native,
            });
        });
        return locales;
    }

}
